(() => {
  const SELECTOR = ".product-item__badge--round";
  const TEXT_SELECTOR = ".sc-product-item__badge-text";
  const MIN_PX = 7;

  const scAvailableBox = (badge) => {
    const style = window.getComputedStyle(badge);
    const padX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const padY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const contentW = Math.max(0, badge.clientWidth - padX);
    const contentH = Math.max(0, badge.clientHeight - padY);
    /* Keep text inside the circle, not just the square bounding box */
    const inscribed = Math.min(badge.clientWidth, badge.clientHeight) * 0.68;

    return {
      width: Math.min(contentW, inscribed),
      height: Math.min(contentH, inscribed),
    };
  };

  const scFitRoundBadgeText = (badge) => {
    const text = badge.querySelector(TEXT_SELECTOR);
    if (!text) return;

    badge.style.fontSize = "";
    const maxPx = parseFloat(window.getComputedStyle(badge).fontSize);
    const box = scAvailableBox(badge);

    if (!maxPx || box.width < 1 || box.height < 1) return;

    const scTextFits = () => {
      const range = document.createRange();
      range.selectNodeContents(text);
      const rect = range.getBoundingClientRect();
      const width = Math.max(text.scrollWidth, rect.width);
      const height = Math.max(text.scrollHeight, rect.height);
      range.detach();
      return width <= box.width + 0.5 && height <= box.height + 0.5;
    };

    let low = MIN_PX;
    let high = maxPx;
    let best = MIN_PX;

    for (let i = 0; i < 12; i += 1) {
      const mid = (low + high) / 2;
      badge.style.fontSize = `${mid}px`;

      if (scTextFits()) {
        best = mid;
        low = mid;
      } else {
        high = mid;
      }
    }

    badge.style.fontSize = `${best}px`;
  };

  const scInitRoundBadgeFit = (root = document) => {
    root.querySelectorAll?.(SELECTOR).forEach((badge) => {
      scFitRoundBadgeText(badge);

      if (badge.dataset.scBadgeFit === "true") return;
      badge.dataset.scBadgeFit = "true";
      scBadgeFitResizeObserver.observe(badge);
    });
  };

  const scBadgeFitResizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => scFitRoundBadgeText(entry.target));
  });

  const scBadgeFitMutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
          scInitRoundBadgeFit(node);
        }
      });
    }
  });

  const scStartRoundBadgeFit = () => {
    scInitRoundBadgeFit();
    scBadgeFitMutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scStartRoundBadgeFit, { once: true });
  } else {
    scStartRoundBadgeFit();
  }

  document.addEventListener("shopify:section:load", (event) => {
    scInitRoundBadgeFit(event.target);
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(() => scInitRoundBadgeFit());
  }
})();
